import React, { useEffect, useRef, useState } from 'react'

export default function BookBanner({ bannerList = [], config = {} }) {
  const bookRef = useRef(null)
  const swiperRef = useRef(null)
  const timerRef = useRef(null)
  const [bookSwiperState, setBookSwiperState] = useState({ next: true, prev: false })

  // Generate a key based on bannerList content so React completely recreates DOM nodes when bannerList changes
  const bannerKey =
    bannerList && bannerList.length > 0
      ? bannerList.map((item, idx) => item.img1 || item.url || idx).join('_')
      : 'empty'

  useEffect(() => {
    if (!bannerList || bannerList.length === 0) return

    const window$ = window.$
    if (!window$) return

    const initTurnAndSwiper = () => {
      if (!bookRef.current) return

      const $book = window$(bookRef.current)

      // Destroy existing turn instance if any
      try {
        if ($book.turn && $book.turn('is')) {
          $book.turn('destroy')
        }
      } catch (e) {
        // ignore
      }

      // Destroy existing swiper instance if any
      if (swiperRef.current) {
        try {
          swiperRef.current.destroy(true, true)
        } catch (e) {
          // ignore
        }
        swiperRef.current = null
      }

      // Initialize turn.js
      $book.turn({
        width: 660,
        height: 450,
        elevation: 150,
        gradients: true,
        autoCenter: false,
        acceleration: true,
        display: 'double',
        page: 2,
        when: {
          turned: function (event, page, view) {
            const pages = window$(this).turn('pages')
            const max = pages - 2
            setBookSwiperState({
              next: !view.includes(max),
              prev: !view.includes(2),
            })
          },
        },
      })

      // Sync initial button disabled state right after turn init
      try {
        const pages = $book.turn('pages')
        const max = pages - 2
        const view = $book.turn('view') || [2, 3]
        setBookSwiperState({
          next: !view.includes(max),
          prev: !view.includes(2),
        })
      } catch (e) {
        // ignore
      }

      // Initialize Swiper without navigation hijacking
      if (window.Swiper) {
        swiperRef.current = new window.Swiper('.swiper-bg', {
          watchSlidesProgress: false,
          allowTouchMove: false,
          slidesPerView: 'auto',
          centeredSlides: false,
          loop: false,
          autoplay: false,
          effect: 'fade',
          mousewheel: false,
        })
      }
    }

    timerRef.current = setTimeout(initTurnAndSwiper, 100)

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
      if (bookRef.current && window.$) {
        try {
          const $book = window.$(bookRef.current)
          if ($book.turn && $book.turn('is')) {
            $book.turn('destroy')
          }
        } catch (e) {
          // ignore
        }
      }
      if (swiperRef.current) {
        try {
          swiperRef.current.destroy(true, true)
        } catch (e) {
          // ignore
        }
        swiperRef.current = null
      }
    }
  }, [bannerKey])

  const turnPage = (type = 'next') => {
    const window$ = window.$
    if (!window$ || !bookRef.current) return

    const $book = window$(bookRef.current)

    try {
      const view = $book.turn('view') || []
      const pages = $book.turn('pages')
      const maxPage = pages - 2

      if (type === 'next') {
        if (!view.includes(maxPage)) {
          $book.turn('next')
          if (swiperRef.current) {
            try {
              swiperRef.current.slideNext()
            } catch (e) {
              // ignore
            }
          }
        }
      } else if (type === 'previous') {
        if (!view.includes(2)) {
          $book.turn('previous')
          if (swiperRef.current) {
            try {
              swiperRef.current.slidePrev()
            } catch (e) {
              // ignore
            }
          }
        }
      }
    } catch (e) {
      // ignore
    }
  }

  return (
    <section id="s2" className="swiper-slide">
      <section className="s2-banner">
        <section className="s2-banner-container" key={`book-container-${bannerKey}`}>
          <div
            className={`banner-prev ${!bookSwiperState.prev ? 'disabled' : ''}`}
            role="button"
            tabIndex={0}
            aria-label="Previous Page"
            onClick={() => turnPage('previous')}
          />
          <section className="book" ref={bookRef}>
            <div className="hard" />
            {bannerList.map((item, idx) => (
              <React.Fragment key={item.img1 || idx}>
                <div className="book-item book-left">
                  <img src={item.img1} alt="" />
                </div>
                <div className="book-item book-right">
                  <img src={item.img2} alt="" />
                </div>
              </React.Fragment>
            ))}
            <div className="hard" />
          </section>
          <div
            className={`banner-next ${!bookSwiperState.next ? 'disabled' : ''}`}
            role="button"
            tabIndex={0}
            aria-label="Next Page"
            onClick={() => turnPage('next')}
          />
        </section>
        <img
          src={`${config.imgBase || ''}banner_text.png`}
          alt="向左翻页查看更多"
          className="banner-text"
        />
      </section>
      <section className="swiper-bg" key={`swiper-bg-${bannerKey}`}>
        <section className="swiper-wrapper">
          {bannerList.map((item, idx) => (
            <section className="swiper-slide" key={item.banner_bg || idx}>
              <div className="bg" />
              {item.title ? <img src={item.title} alt="" className="img-title" /> : null}
              {item.url && item.url.endsWith('.mp4') ? (
                <video src={item.url} autoPlay loop muted className="img-content" />
              ) : (
                <img src={item.url || item.bg} alt="" className="img-content" />
              )}
            </section>
          ))}
        </section>
      </section>
    </section>
  )
}


